import { Provider } from '@angular/core';
import { METERS_STORE, resolveMetersStoreMode } from './meters-store.interface';
import { MetersMockStore } from './meters-mock-store.service';
import { MetersFirestoreStore } from './meters-firestore-store.service';

/**
 * Route-level provider that wires `METERS_STORE` to the right implementation
 * based on `?store=firestore|mock` (sticky via localStorage).
 *
 * Defaults to **firestore** — meter data is persisted user data and must hit
 * real Firestore in production. The mock store is for demos, Storybook and
 * tests. Add `provideMetersStore()` to the feature route's providers (or to
 * any consuming component's providers) — NOT to the root `providers` array,
 * because the store holds property-scoped state that must not leak across
 * navigation between properties.
 *
 * Example:
 * ```ts
 * {
 *   path: ':id',
 *   component: PropertyDetailComponent,
 *   providers: [provideMetersStore()],
 *   children: [...]
 * }
 * ```
 */
export function provideMetersStore(): Provider[] {
  return [
    MetersMockStore,
    MetersFirestoreStore,
    {
      provide: METERS_STORE,
      useFactory: (mock: MetersMockStore, firestore: MetersFirestoreStore) =>
        resolveMetersStoreMode() === 'mock' ? mock : firestore,
      deps: [MetersMockStore, MetersFirestoreStore]
    }
  ];
}
